import React from 'react';
import { Gift } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    num: '01',
    title: 'Banco de Actividades Agropecuarias',
    desc: 'Actividades listas para usar en clase sin adaptar'
  }, {
    num: '02',
    title: 'Sistema de Evaluación con Rúbricas',
    desc: 'Evaluaciones completas con criterios claros'
  }, {
    num: '03',
    title: 'Proyectos Agro Listos',
    desc: 'Proyectos para trabajos prácticos y ferias'
  }, {
    num: '04',
    title: 'Casos Reales Argentinos',
    desc: 'Ejemplos reales del agro, producción y economía'
  }];
  return <section className="py-10 md:py-16 px-4 bg-brand-dark border-y border-brand-accent/20" data-id="element-17">
      <div className="max-w-4xl mx-auto" data-id="element-18">
        <div className="text-center mb-8" data-id="element-19">
          <h2 className="text-2xl md:text-4xl font-black text-white" data-id="element-20">
            🎁 4 BONUS ESTRATÉGICOS
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 mb-8" data-id="element-21">
          {bonuses.map((bonus, i) => <div key={i} className="bg-brand-card rounded-xl p-5 border border-white/10 hover:border-brand-accent/30 transition-colors relative overflow-hidden group" data-id="element-22">
              <div className="absolute -right-4 -top-4 w-20 h-20 bg-brand-accent/10 rounded-full group-hover:scale-150 transition-transform duration-500" data-id="element-23"></div>

              <div className="flex items-start mb-3 relative z-10" data-id="element-24">
                <div className="bg-brand-accent text-white font-black text-lg w-10 h-10 rounded-lg flex items-center justify-center mr-3 shrink-0" data-id="element-25">
                  {bonus.num}
                </div>
                <div data-id="element-26">
                  <div className="flex items-center gap-1.5 mb-0.5" data-id="element-27">
                    <Gift className="w-3.5 h-3.5 text-brand-accent" data-id="element-28" />
                    <span className="text-brand-accent font-bold text-xs tracking-widest uppercase" data-id="element-29">
                      BONUS {bonus.num}
                    </span>
                  </div>
                  <h3 className="text-lg font-bold leading-tight text-white" data-id="element-30">
                    {bonus.title}
                  </h3>
                </div>
              </div>

              <p className="text-sm text-gray-400 relative z-10" data-id="element-31">
                {bonus.desc}
              </p>
            </div>)}
        </div>

        <div className="bg-brand-card rounded-xl p-4 text-center border border-brand-accent/20 max-w-xl mx-auto" data-id="element-32">
          <p className="text-lg md:text-xl font-medium text-gray-300" data-id="element-33">
            💰 Valor total bonos:{' '}
            <span className="line-through text-gray-600" data-id="element-34">$35.000</span>{' '}
            <span className="text-brand-accent font-black neon-glow" data-id="element-35">
              👉 HOY GRATIS
            </span>{' '}
            con tu kit
          </p>
        </div>
      </div>
    </section>;
}